import { createSlice } from "@reduxjs/toolkit";
import { getProductAction } from "../../actions/product/getProductAction";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const getProductSlice = createSlice({
  name: "getProduct",
  initialState,
  reducers: {
    // cleargetProductsState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProductAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getProductAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { cleargetProductsState } = getProductsSlice.actions;
export default getProductSlice.reducer;
